<template>
	<div class="home">
		<!-- <span>{{hasHead}}</span> -->
		<div class="headCon">
			<ul v-show="hasHead" class="head">
				<li @click="toProductFilter(-1)" :class="menuNum ==  -1? 'active' : ''">全部</li>
				<li @click="toProductFilter(index)" class="eachClassify" :class="index == menuNum ? 'active' : ''" v-for="(item,index) in classifyArr"
				 :key="index">
					{{item.name}}
				</li>
			</ul>
			<div class="arrow"></div>
		</div>

		<div v-show="showHeadTab" class="headTab" :class="whichHeight == 1 ? 'noMargin' : '' ">
			<el-select v-if="loadOver" v-model="selectValue" placeholder="全部" @change="changeMenu">
				<el-option label="全部" value="">
				</el-option>
				<el-option v-for="item in classifyArr[menuNum].childrenMenu" :key="item.id" :label="item.name" :value="item.id">
				</el-option>
			</el-select>
			<span v-else style="width: 0.1rem;"></span>
			<span @click="changeIsBook()" :class="isNeedBook ? 'active' : '' ">免预约</span>
			<span @click="changeIsSales(2)" :class="isSales ? '' : 'active' ">离我最近</span>
			<span @click="changeIsSales(1)" :class="isSales ? 'active' : '' ">销量</span>
			
		</div>

		<div class="ProductList" :class="{height1 : whichHeight==1 , height2:whichHeight==2 , dianShang : isDianShang}" v-if="isRouterAlive">
			<ProductList :typeName="typeMes"></ProductList>


		</div>

		<FootTab></FootTab>
	</div>
</template>

<script>
	import Vue from 'vue';
	import ProductList from "@/components/ProductList.vue";
	import FootTab from "@/components/FootTab.vue";
	export default {
		name: "productFilter",
		components: {
			FootTab,
			ProductList
		},
		data() {
			return {
				"hasHead": false,
				"typeMes": {
					"menuId":"",	//菜单id
					"menuLevel":"",	//菜单等级
					"name":"",		//菜单名
					"type":2,	//1销量，2离我最近
					"isBook":1		,//1免预约，""全部
					"description":""
				},

				classifyArr: [],

				"isRouterAlive": false,
				
				"selectValue":"",
				"menuNum":1,
				"loadOver":false,
				"isSales":false,
				"isNeedBook":true,
				
				"whichHeight":2,
				
				"showHeadTab":true,
				
				"isDianShang":false
			}
		},
		activated() {

		},
		created() {

		},
		mounted() {
			var that = this;
			that.menuNum = localStorage.getItem("menuNum") || -1;
			that.typeMes.description = that.$route.query.description || "";
			// that.typeMes.menuLevel = localStorage.getItem("menuLevel") || "";
			
			that.selectValue = localStorage.getItem("selectValue") || "";
			
			console.log(that.typeMes.description,"111111122")
			if (that.typeMes.description == "") {
				that.whichHeight = 2;
			} else{
				that.whichHeight = 1;
				
			}
			console.log(that.whichHeight,"ddddd")
			
			if (that.$route.query.noBook == 'true') {
				this.typeMes.isBook = "";
				this.isNeedBook = false;
				
			}

			if (that.$route.query.hasHead == 'false') {
				that.hasHead = false;
			} else {
				that.hasHead = true;
			}

			// 获取美食餐饮等菜单
			that.http.getBizMenuList({}).then((res) => {
				console.log(res.data);
				that.classifyArr = res.data.data;
				// that.classifyArr.pop();
				
				if (that.menuNum == -1) {
					that.loadOver = false;
				}else{
					that.loadOver = true;
					
					if (that.typeMes.description == "") {
						if (that.selectValue) {
							that.typeMes.menuId = that.selectValue;
							localStorage.setItem("menuLevel",2);
							that.typeMes.menuLevel = 2;
						} else{
							that.typeMes.menuId = res.data.data[that.menuNum].id;
							if (res.data.data[that.menuNum].id == 45) {
								that.showHeadTab = false;
								that.isDianShang = true;
							} else{
								that.showHeadTab = true;
								that.isDianShang = false;
							}
							localStorage.setItem("menuLevel",1);
							that.typeMes.menuLevel = 1;
						}
					}
					
					
					that.typeMes.name = res.data.data[that.menuNum].name;
					
					
					setTimeout(function () {
						document.getElementsByClassName('eachClassify')[that.menuNum].scrollIntoView();
					},200)
				}
				
				
				
				that.isRouterAlive = true;
			})
			
			
		},
		methods: {
			defImg() { // 图片加载失败时加载占位图
				let img = event.srcElement;
				img.src = this.defaultImg;
				img.onerror = null; //防止闪图
			},
			scrollView(){
				
			},
			toProductFilter(idnexNum) {
				var that = this;
				that.isSales = false;
				if (idnexNum == -1) {
					that.typeMes.menuId = "";
					that.typeMes.menuLevel = "";
					localStorage.setItem("menuLevel","");
					that.typeMes.name = "";
					that.typeMes.type = 1;
					that.menuNum = idnexNum;
					localStorage.setItem("menuNum",idnexNum);
					
					that.loadOver = false;
				}else{
					if (that.classifyArr[idnexNum].id == 45) {
						that.showHeadTab = false;
						that.isDianShang = true;
						
					} else{
						that.showHeadTab = true;
						that.isDianShang = false;
					}
					
					that.typeMes.menuId = that.classifyArr[idnexNum].id;
					that.typeMes.menuLevel = 1;
					localStorage.setItem("menuLevel",1);
					that.typeMes.name = that.classifyArr[idnexNum].name;
					that.typeMes.type = 2;
					that.menuNum = idnexNum;
					localStorage.setItem("menuNum",idnexNum);
					
					that.loadOver = false;
					that.selectValue = "";
					localStorage.setItem("selectValue","");
					setTimeout(function () {
						that.loadOver = true;
					},100)
				}
				
				
				
				
				that.reload();
			},
			reload() {
				this.isRouterAlive = false;
				this.$nextTick(() => (this.isRouterAlive = true));
			},
			changeMenu(){
				console.log(this.selectValue);
				this.typeMes.menuId = this.selectValue;
				localStorage.setItem("selectValue",this.selectValue);
				this.typeMes.menuLevel = 2;
				localStorage.setItem("menuLevel",2);
				this.reload();
			},
			changeIsSales(type){
				this.typeMes.type = type;
				
				if (type == 1) {
					this.isSales = true;
				} else{
					this.isSales = false;
				}
				this.reload();
			},
			changeIsBook(){
				this.isNeedBook = !this.isNeedBook;
				if (this.isNeedBook == true) {
					this.typeMes.isBook = 1;
				} else{
					this.typeMes.isBook = "";
				}
				console.log(this.typeMes,"oooooooo")
				this.reload();
			}
		}

	};
</script>

<style scoped lang="scss">
	.home {
		height: 100vh;
		overflow: auto;
		padding-bottom: 0.9rem;
		padding-top: 0.3rem;
		background-color: #f9f9f9;
		
		.headCon{
			position: relative;
			
			.head::-webkit-scrollbar {
				display: none;
				/* Chrome Safari */
			}
			
			.head {
				white-space: nowrap;
				width: calc(100% - 0.5rem);
				overflow-x: auto;
				scrollbar-width: none;
				/* firefox */
				-ms-overflow-style: none;
				/* IE 10+ */
				padding: 0rem 0rem 0rem 0.3rem;
				position: relative;
				// height: 0.4rem;
				// line-height: 0.4rem;
			
				li {
					display: inline-block;
					vertical-align: middle;
					color: #333333;
					font-size: 0.3rem;
					// font-weight: bold;
					padding-right: 0.5rem;
					position: relative;
					padding-bottom: 0.16rem;
				}
			
				li.active {
					color: #ff6600;
					font-weight: bold;
				}
				
				li.active::before{
					content: "";
					position: absolute;
					width: 0.23rem;
					height: 0.19rem;
					background-image: url(../assets/sqzsIco5.png);
					background-size: cover;
					right: 0.33rem;
					bottom: 0rem;
				}
				
			}
			
			.arrow{
				position: absolute;
				top: 0.06rem;
				right: 0.16rem;
				width: 0.13rem;
				height: 0.2rem;
				background-image: url(../assets/arrow_right.png);
				background-size: cover;
			}
		}
		
		
		.noMargin{
			margin-top: 0 !important;
		}
		.headTab {
			text-align: left;
			padding-bottom: 0.3rem;
			padding-left: 0.2rem;
			box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.1);
			margin-top: 0.1rem;

			span {
				display: inline-block;
				vertical-align: middle;
				margin-left: 0.2rem;
				font-size: 0.28rem;
				color: #333333;
				font-weight: bold;
				background-color: #fff;
				height: 0.6rem;
				line-height: 0.6rem;
				padding: 0px 0.2rem;
				border-radius: 4px;
			}

			span.active {
				color: #fb8a17;
			}

			span:first-child {
				margin-left: 0;
			}
		}

		.ProductList {
			padding: 0px 0.24rem;
			background-color: #f9f9f9;
		}


		.ProductList.height1 {
			height: calc(100vh - 1.9rem);
		}

		.ProductList.height2 {
			height: calc(100vh - 2.7rem);
		}
		
		.ProductList.dianShang {
			height: calc(100vh - 2.02rem);
			margin-top: 0.2rem;
		}

	}
</style>
